import effects from 'app/effects/effects'
import * as R from 'ramda'

import { sortLanguage } from 'commons/language'

export const fetchLanguages = () => {
  return effects.apis
    .getAllLanguage()
    .then(R.compose(sortLanguage, R.prop('data')))
}

export const allLanguages = async () => {
  const languages = await fetchLanguages()
  return languages
}
